// extracted by mini-css-extract-plugin
export default {"spinner-container":"PositionLoader_spinner-container__Nyhmv","spinner-border":"PositionLoader_spinner-border__K2pWV"};